module.exports = __webpack_public_path__ + "resources/img/img_iTracerAF1_en.79d1890d7d72cd2cd682124acfd80c79.png";